/**
 * Convert an array to a CSV string
 * @param array Array to convert
 * @param spaces Add spaces after commas
 * @returns CSV string
 *
 * @example
 * ```ts
 * const csv = arrayToCsv(['a', 'b', 'c']); // "a","b","c"
 * ```
 */
export const arrayToCsv = (
	array?: string | (number | string)[],
	spaces?: boolean,
) => {
	if (typeof array === 'string') return array;
	if (!array || !Array.isArray(array)) return '';
	return array.map((v) => `"${v}"`).join(`,${spaces ? ' ' : ''}`);
};

export default arrayToCsv;
